import { createElement } from "react";
import { hydrateRoot } from "react-dom/client";

import Error from "./Error";
import { initializeClient } from "../../utils/clientInit";

const attributeValue = (attributeName: string) => {
  const scriptTag = document.getElementById("js");
  return scriptTag.getAttribute(`data-prop-${attributeName}`) || "";
};

const props = {
  amount: parseInt(attributeValue("amount"), 10),
  storeLogo: attributeValue("store-logo"),
  storeName: attributeValue("store-name"),
  orderRef: attributeValue("order-ref"),
  oneLinkOverPlusLimitCannotRetry: attributeValue("one-link-over-plus-limit-cannot-retry"),
  oneLinkOverPlusLimitCanRetry: attributeValue("one-link-over-plus-limit-can-retry"),
  oneLinkCheckoutExceededNlpLimitRetriable: attributeValue("one-link-checkout-exceeded-nlp-limit-retriable"),
  oneLinkCheckoutExceededNlpLimit: attributeValue("one-link-checkout-exceeded-nlp-limit"),
  oneLinkCheckoutOverNlpLimitCanRetry1x: attributeValue("one-link-checkout-over-nlp-limit-can-retry-1x"),
  oneLinkCheckoutOverNlpLimitCannotRetry1x: attributeValue("one-link-checkout-over-nlp-limit-cannot-retry-1x"),
  oneLinkMerchantRequiresKyc: attributeValue("one-link-merchant-requires-kyc"),
};

// Initialize client-side services (non-blocking)
initializeClient();

// Hydrate immediately to ensure interactivity
hydrateRoot(document.getElementById("app"), createElement(Error, props));
